import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ThemeProvider } from "./context";
import "./index.css";

// Disable right-click context menu (optional for security)
// document.addEventListener("contextmenu", (e) => e.preventDefault());

// Block DevTools keyboard shortcuts (F12, Ctrl+Shift+I, etc.) - development only
function blockDevToolsShortcuts(event) {
    if (process.env.NODE_ENV === 'production') {
        const forbiddenKeys = [123, 73]; // F12 and 'I' key (for Ctrl+Shift+I)
        if (
            (event.keyCode === forbiddenKeys[0]) || // F12
            (event.keyCode === forbiddenKeys[1] && (event.ctrlKey || event.metaKey) && event.shiftKey) // Ctrl+Shift+I
        ) {
            event.preventDefault();
        }
    }
}

// Attach event listener to block DevTools shortcuts
document.addEventListener("keydown", blockDevToolsShortcuts);

// Render the app
ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root")
);
